import React from "react";
import Rating from "@mui/material/Rating";
import { useNavigate } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

function ChefCard(props) {
  const navigate = useNavigate();

  const chef = props.data;

  const navigateToDetail = (chef_id) => {
    localStorage.setItem("chef_id", chef_id);

    navigate("/browse-chef", {
      state: {
        option: props?.option ?? null,
      },
    });
  };

  return (
    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-4 d-flex justify-content-center">
      <div
        className="chef-card"
        onClick={() => navigateToDetail(chef.chef_id)}
      >
        {/* IMAGE SECTION */}
        <div className="chef-image-wrapper">
          <OwlCarousel
            items={1}
            autoplay
            loop
            dots
            nav={false}
            mouseDrag
            touchDrag
            autoplayHoverPause
            smartSpeed={700}
            className="owl-theme chef-carousel"
          >
            {/* Main Image */}
            <div className="chef-image-container">
              <img
                src={chef.chef_profile_image}
                alt={chef.chef_name}
                className="chef-image"
              />
            </div>

            {/* Additional Images */}
            {chef?.chef_images?.map((img, index) => (
              <div className="chef-image-container" key={index}>
                <img
                  src={img}
                  alt={`chef-${index}`}
                  className="chef-image"
                />
              </div>
            ))}
          </OwlCarousel>

          {/* TOP BADGE */}
          <div className="chef-badge">
            ⭐ {chef?.chef_rating || "4.5"}
          </div>
        </div>

        {/* BODY */}
        <div className="chef-card-body">
          {/* NAME */}
          <div className="chef-top-row">
            <h5 className="chef-name">{chef.chef_name}</h5>

            <Rating
              value={Number(chef.chef_rating)}
              precision={0.5}
              readOnly
              size="small"
            />
          </div>
          {/* BOTTOM INFO */}
          <div className="chef-bottom-row">
            {/* Orders */}
            <div className="chef-info-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ff6b35"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
                <path d="m9 16 2 2 4-4" />
              </svg>

              <span>{chef.booking_count} Orders</span>
            </div>


          </div>


        </div>
      </div>

      {/* CSS */}
      <style jsx>{`
       /* CARD */
.chef-card {
  width: 100%;
  max-width: 360px;
  height: 430px;
  border-radius: 22px;
  overflow: hidden;
  background: #ffeeeb; 
  border: 1.5px solid #ffd2c7;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.chef-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 35px rgba(0, 0, 0, 0.12);
}

/* IMAGE SECTION */
.chef-image-wrapper {
  position: relative;
  height: 250px;
  background: #f8f8f8;
  overflow: hidden;
}

.chef-image-container {
  width: 100%;
  height: 250px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #f8f8f8;
}

.chef-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* NO IMAGE CUT */
  transition: transform 0.4s ease;
}

.chef-card:hover .chef-image {
  transform: scale(1.03);
}

/* RATING BADGE */
.chef-badge {
  position: absolute;
  top: 14px;
  right: 14px;

  background: rgba(255, 255, 255, 0.95);
  padding: 6px 12px;
  border-radius: 30px;

  font-size: 13px;
  font-weight: 600;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* BODY */
.chef-card-body {
  padding: 18px;
  flex: 1;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* NAME + RATING */
.chef-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.chef-name {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  color: #111;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 180px;
}

/* ORDERS */
.chef-bottom-row {
  margin-top: 18px;
}

.chef-info-box {
  display: flex;
  align-items: center;
  gap: 10px;

  background: rgba(255, 255, 255, 0.7);

  border-radius: 14px;
  padding: 12px 14px;

  font-size: 14px;
  font-weight: 600;
  color: #333;

  backdrop-filter: blur(8px);
}

/* OWL DOTS */
.chef-carousel .owl-dots {
  position: absolute;
  bottom: 8px;
  width: 100%;
}

.chef-carousel .owl-dot span {
  background: rgba(255, 255, 255, 0.7) !important;
}

.chef-carousel .owl-dot.active span {
  background: #000 !important;
}

/* MOBILE */
@media (max-width: 768px) {
  .chef-card {
    height: 410px;
  }

  .chef-name {
    font-size: 17px;
  }
}
      `}</style>
    </div>
  );
}

export default ChefCard;